import { render, staticRenderFns } from "./componentItemRender.vue?vue&type=template&id=38faef70&scoped=true"
import script from "./componentItemRender.vue?vue&type=script&lang=js"
export * from "./componentItemRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38faef70",
  null
  
)

export default component.exports